import MainMenu from '@/components/foundation/main-menu/MainMenu'
import BoardDetail from '@/view/board/Board'

export default {
  path: '/board',
  name: 'Board',
  components: {
    default: BoardDetail,
    mainMenu: MainMenu
  },
  meta: {
    // auth: true,
    mainArea: 'board',
    area: 'board',
    breadcrumb: [
      { name: 'Quadro' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/board/BoardRoute.js